/**
 * Ouverture du module Dialog (app embed IA) depuis une ancre d'URL :
 * https://www.poderm.com/#dialog-ai-bar — utilisable en newsletter, blog, social.
 *
 * L'app expose son API via un CustomEvent sur window :
 *   detail.type ∈ { PRODUCT_QUESTION, GENERIC_QUESTION, START_DIAGNOSTIC,
 *                   CLOSE_DIALOG, OPEN_WITH_SUGGESTIONS, REOPEN_CONVERSATION }
 * REOPEN_CONVERSATION est le seul type qui ouvre le module sans payload requis.
 * Le widget est monté en asynchrone : window.dialogAssistant.isReady, sinon
 * attendre l'event `dialogAssistant:ready`.
 */
(() => {
  const TARGET_HASH = '#dialog-ai-bar';

  const openDialog = () => {
    window.dispatchEvent(
      new CustomEvent('enableDialogAssistantEvent', {
        detail: { type: 'REOPEN_CONVERSATION', payload: {} },
      })
    );
  };

  const handleHash = () => {
    if (window.location.hash !== TARGET_HASH) return;

    // Hash retiré une fois consommé : l'URL reste propre et un nouveau clic sur
    // le même lien depuis la page redéclenche bien un `hashchange`.
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.search
    );

    if (window.dialogAssistant && window.dialogAssistant.isReady) {
      openDialog();
    } else {
      window.addEventListener('dialogAssistant:ready', openDialog, { once: true });
    }
  };

  window.addEventListener('hashchange', handleHash);
  handleHash();
})();
